(function () {
    angular.module('ngmvac').
    directive('mapCoordinates', ['$compile', function ($compile) {
        // directive link function
        var link = function (scope, element, attrs) {
            var hotel = [];
            if (attrs.marca == 'mvac') {
                styleOutle = {};
                markerIcon = '/img/marker.png';
            } else {
                markerIcon = '/outlet_img/marker.png';
            }

            initMap = function () {
                var center = new google.maps.LatLng(1, 1);
                bounds = new google.maps.LatLngBounds();
                var zoom =19;
                var map = new google.maps.Map(element[0], {
                    zoom: zoom,
                    center: center,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    scrollwheel: false,
                    styles: styleOutle
                });
                var marker, infowindow;
                var count = 0;
                marker_objects = [];

                for (var i = 0; i < scope.places.length; i++) {
                    if(scope.places[i].latitude == null)
                        count++;
                    if (scope.places[i].latitude != 0 && scope.places[i].id != 1666 && (scope.places[i].latitude != null && scope.places[i].longitude != null)) {

                        var cotizadorSeleccionado = localStorage.getItem('cotizadorSeleccionado');
                        if(cotizadorSeleccionado == null || window.location.pathname == "/destinos-con-auto-incluido/Mexico"){
                            localStorage.setItem('cotizadorSeleccionado', 1);
                        }

                        html = "";
                        html += "<div class='row mr0'>";
                        var name = scope.places[i].name.replace(/\s/g, "_");
                        html += "<div class='col-md-12' style='height: 70px;'>";
                        html += "<a href='"+globalToCountry(scope.places[i])+"'>";
                        html += "<div class='priceMap' style='font-size:20px;margin-bottom: 10px;'>" + scope.places[i].name + "<br></div>";
                        html += "<div class='label label-success lbver'>" + scope.places[i].total + " Hoteles en el destino " + "</div>";
                        html += "</a>"
                        html += "</div>";
                        html += "</div>";

                        latlngset = new google.maps.LatLng(scope.places[i].latitude, scope.places[i].longitude);
                        marker = new google.maps.Marker({
                            map: map, title: html, position: latlngset
                        });

                        infowindow = new google.maps.InfoWindow()
                        google.maps.event.addListener(marker, "mouseover", (function(marker) {
                            return function(evt) {
                                var content = marker.getTitle();
                                infowindow.setContent(content);
                                infowindow.open(map, marker);
                            }
                        })(marker));

                        marker_objects.push(marker);
                    }
                }

                $.each(marker_objects, function(index, marker) {
                    bounds.extend(marker.position)
                });
                map.fitBounds(bounds);
            }
            globalToCountry = function (item) {
                var today = (moment().add(14,'days')).format('YYYY-MM-DD');
                var tommorrow = (moment().add(15,'days')).format('YYYY-MM-DD');
                var url = "";
                url  += '/load?rt=hotel';
                url += '&source=MVAC';
                url += '&language=CAS';
                url += '&adults_1=2';
                url += '&children_1=0';
                url += '&type=Destiny';
                url += '&checkIn='+today;
                url += '&checkOut='+tommorrow;
                url += '&code=';
                url += item.code;

                item.name = item.name.replace('/', '-');
                item.name = item.name.replace(/ñ/gi, "n");
               return url;
            }
            initMap();
        };
        return {
            restrict: 'A',
            template: '<div class="mapa-rates"></div>',
            replace: true,
            link: link,
            controller: ['$scope', 'ContentApiService', function (scope, resul) {
                // scope.img = function (hotel) {
                //     return resul.get([hotel.code], ['images', 'categoryCode', 'description', 'chainCode']);
                // }
            }],
            scope: {
                places: "="
            }
        };
    }]);
})();